import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  MenuItem,
  Select,
  Box,
  Button,
  TextField,
  SelectChangeEvent,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import React from "react";

const ManageProducts = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [type, setType] = React.useState("default");

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  const products = [
    {
      id: "#PROD-001",
      name: "Men Sports Shoes",
      category: "Footwear",
      brand: "Nike",
      status: true,
      createdDate: "30 July 2025",
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD-002",
      name: "Men Sports Shoes",
      category: "Footwear",
      brand: "Nike",
      status: true,
      createdDate: "30 July 2025",
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD-003",
      name: "Men Sports Shoes",
      category: "Footwear",
      brand: "Nike",
      status: true,
      createdDate: "30 July 2025",
      image: "/static/images/placeholder.png",
    },
  ];

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <div className="main_title ">
        <h1>Manage Products</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          Manage Products
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button className="btn btn_primary">Upload CSV</Button>
            <Button className="btn btn_primary">Export CSV</Button>
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/add-product")}
            >
              <AddIcon /> Add Products
            </Button>
          </div>
        </div>

        <TableContainer className="table_container" sx={{ mt: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Product Detail</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Brand</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredProducts.map((item, index) => (
                <TableRow key={index} hover>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={2}>
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "6px",
                          objectFit: "cover",
                          background: "#f5f5f5",
                        }}
                      />
                      <span>{item.name}</span>
                    </Box>
                  </TableCell>
                  <TableCell>{item.category}</TableCell>
                  <TableCell>{item.brand}</TableCell>
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>
                  <TableCell>{item.createdDate}</TableCell>
                  <TableCell>
                    <Box display="flex" gap={1}>
                      <IconButton>
                        <img onClick={() => navigate('/manage-products/view')} src="/static/images/eye_icon.svg" alt="View" />
                      </IconButton>
                      <IconButton >
                        <img onClick={() => navigate('/add-product')} src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageProducts;
